module.exports = __webpack_public_path__ + "static/media/6 1 Ordforstaelse Intro.bc4091f1.mp3";